
import { mapState } from 'vuex';
import AppSvgIcon from '@/components/core/AppSvgIcon';
import TransitionExpand from '@/transitions/TransitionExpand';

export default {
  i18nComponentKey: 'WidgetAddOnSizeRecommendationPopup.components.SizeRecommendationSizeOptionStats',
  name: 'SizeRecommendationSizeOptionStats',
  components: { AppSvgIcon, TransitionExpand },
  props: {
    sizeOptionStats: { type: Array, required: true }
  },
  data() {
    return {
      isExpanded: false
    };
  },
  computed: {
    ...mapState('reviewSettings', ['reviewSettings']),
    mostPurchasedSize() {
      return this.sizeOptionStats[0] && this.sizeOptionStats[0].name;
    }
  }
};
